import { render, staticRenderFns } from "./FrequentItem.vue?vue&type=template&id=2cb4c2ba&scoped=true&"
import script from "./FrequentItem.vue?vue&type=script&lang=js&"
export * from "./FrequentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb4c2ba",
  null
  
)

export default component.exports